import React, {useState, useRef, useEffect} from 'react';
import {Col, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import PopUp from "../popUp/PopUp";
import FireStatusManage from "../../pages/subPages/FireStatusManage";
import FireEventDetail from "../../pages/subPages/FireEventDetail";
import AxcBadge from "../common/AxcBadge";
import Pagination from "../common/Pagination";
import {getFireStatus} from "../../api/apiClient";
import Moment from "moment";
import Swal from "sweetalert2";
import TableTopBar from "./top/TableTopBar";
import {exportExcel} from "../../common/exportExcel";
import {exportPdf} from "../../common/exportPdf";
import useAuth from "../../hook/useAuth";
import usePdf from "../../hook/usePdf";


const TableFireStatus = ({
                           currentPage,
                           setCurrentPage,
                           listPageSize,
                           setListPageSize,
                           total,
                           tableList,
                           updateList,
                           setIsSearch,
                           setTableList,
                           setTotal,
                           searchParam,
                           propAuth
                         }) => {

  /*const [auth, setAuth] = useState("0");

  useEffect(() => {
    setAuth(sessionStorage.getItem("CURRENT_AUTH"));
  }, []);*/

  // const auth = useAuth();
  // console.log(auth);

  // select ////////////////////////////////////
  const updatePageSize = (aSize) => {
    setIsSearch(true);
    setCurrentPage(1);
    setListPageSize(parseInt(aSize));
  };

  const tableRef = useRef(null);
  const [isExport, setIsExport] = useState(false);

  const onDownload = () => {
    exportExcel(tableRef, "화재현황_.xls")
  }

  const getAllList = () => {
    setIsExport(true);

    // 전체 리스트 get API 없음 - 10000건으로 임시 처리
    getFireStatus(currentPage, 10000,
        Moment(searchParam.startDate).format('YYYY-MM-DD'),
        Moment(searchParam.endDate).format('YYYY-MM-DD'),
        searchParam.fclty_cd,
        searchParam.fire_status)
        .then(res => {
          if (res.data.data !== undefined) {
            setTableList(res.data.data.list);
            setTotal(res.data.data.total);
          }
        });
  };

  const downloadExcelToTable = () => {
    getAllList();

    Swal.fire({
      title: `EXCEL 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
      }
      setIsExport(false);
      updateList();
    })
  };

  const exportReport = () => {
    getAllList();

    Swal.fire({
      title: `PDF 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        exportPdf(tableRef, '화재현황_' + Date.now() + '.pdf')
      }
      setIsExport(false);
      updateList();
    });
  };

  const onClickFclty = (e) => {
    openLarge(e.target.dataset.id);
  };

  const onClickDetail = (e) => {
    openPopLayer(e.target.dataset.id);
  };

  const [stPopLayer, setPopLayer] = useState(false);
  const [stFireNo, setFireNo] = useState(0);

  const openPopLayer = (fireNo) => {
    setFireNo(fireNo);
    setPopLayer(true);
  };

  const [stPopLarge, setPopLarge] = useState(false);
  const [stPopLargeData, setPopLargeData] = useState({})

  const openLarge = (id) => {
    setPopLargeData(tableList[id]);
    setPopLarge(true);
  };

  const closeFireStatus = () => {
    setPopLarge(false);
    updateList();
  };


  return (
      <>
        <PopUp
            propTitle={'화재현황 관리'}
            propShow={stPopLarge}
            propSize={'lg'}
            setShow={setPopLarge}
            // propDialogClassName={"modal-90w"}
        >
          <FireStatusManage
              propData={stPopLargeData}
              setClose={closeFireStatus}
          />
        </PopUp>
        <PopUp
            propTitle={'화재 이벤트 상세'}
            propShow={stPopLayer}
            setShow={setPopLayer}
        >
          <FireEventDetail
              propFireNo={stFireNo}
              propStartDate={searchParam.startDate}
              propEndDate={searchParam.endDate}
          />
        </PopUp>
        <Row>
          <Col md={6}>
            <TableTopBar
                propSelectOption={{
                  isEnable: true,
                  selItems: [15, 30, 50], //미구현
                  setFunc: updatePageSize,
                }}
                propExcelExport={{
                  isEnable: true,
                  exportFilename: 'doc.xlsx',
                  getFunc: null,
                }}
                propExcelDownload={{
                  isEnable: true,
                  getFunc: downloadExcelToTable,
                }}
                /*propPdfExport={{
                  isEnable: true,
                  // exportFilename: 'doc.pdf',
                  getFunc: exportReport,
                }}*/
                propPdf={{
                  isEnable: true,
                  getFunc: usePdf({
                    tableRef: tableRef,
                    setIsExport: setIsExport,
                    getAllList: getAllList,
                    updateList: updateList,
                    filename: '화재현황',
                  }),
                }}
                // propDelete={{
                //   isEnable: true,
                //   delFunc: delItem,
                // }}
                // propReg={{
                //   isEnable: true,
                //   regFunc: regItem,
                // }}
                // propControl = {{
                //     isEnable: true,
                //     ctlFunc: null,
                // }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} className={'table-responsive-md'}>
            <div className={"table-responsive text-nowrap"}>
              <BootstrapTable hover className={"table text-center"} ref={tableRef}>
                <thead className={"table-head text-secondary"}>
                <tr className={"text-start"}>
                  <th className={"col-md-1"}>시설명</th>
                  <th className={"col"}>화재상태</th>
                  <th className={"col"}>발생시간</th>
                  <th className={"col"}>종료시간</th>
                  <th className={"col"}>수정자</th>
                  <th className={"col-md-3"}>시설주소</th>
                  {isExport ? '' : <th className={"col"}>이벤트 상세</th>}
                </tr>
                </thead>
                <tbody className={`table-body text-start ${isExport ? "" : "text-white"} `}>
                {
                  Array.isArray(tableList) ?
                      (tableList.map((elem, idx) => {
                        return <tr key={idx}>
                          <td
                              className={`${propAuth === "2" ? "column-title" : ''}`}
                              onClick={(e) => {
                                if (propAuth === "2") {
                                  onClickFclty(e);
                                }
                              }}
                              data-id={idx}
                          >
                            {elem.fclty_nm}
                          </td>
                          <td>
                            <AxcBadge propInput={elem.fire_sttus_nm}
                                      propDangerText={'화재발생'}
                            />
                          </td>
                          <td>{elem.ocrn_dt_str}</td>
                          <td>{elem.end_dt_str}</td>
                          <td>{elem.updusr_id}</td>
                          <td>{elem.locplc_addr}</td>
                          {
                            isExport ? '' :
                                (<td>
                                  <Button onClick={onClickDetail} data-id={elem.fire_no}>
                                    상세보기
                                  </Button>
                                </td>)
                          }
                        </tr>;
                      })) :
                      ('')
                }
                </tbody>
              </BootstrapTable>
            </div>
          </Col>
          <Col className={""}>
            <Pagination
                propCurPage={currentPage}
                propTotal={total}
                propPageSize={listPageSize}
                propSetNewPage={setCurrentPage}
                propSetIsSearch={setIsSearch}
            />
          </Col>
        </Row>
      </>
  );
};

export default TableFireStatus;
